import React from "react";

export const ObjectiveContext = React.createContext({});
